<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Manage Document</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="loadingDocument">
    <div class="alert alert-info">Loading...</div>
  </div>

  <div class="modal-body" *ngIf="!loadingDocument && (document !== null)">

    <div>
      <p class="mb-0">
        Template Name:
        <b>{{ document.template_name }}</b>
      </p>
      <p class="mb-0">
        Document Type:
        <b>{{ getDocumentTypeDisplay(document.document_type) }}</b>
      </p>
      <p class="mb-0" *ngIf="getDocumentUserTypeDisplay(document.user_type) !== ''">
        User Type:
        <b>{{ getDocumentUserTypeDisplay(document.user_type) }}</b>
      </p>
      <p class="mb-0" *ngIf="document.completed_at">
        Completed At:
        <b>
          {{ timeStringFromISO8601(document.completed_at) }},
          {{ dateStringFromISO8601(document.completed_at) }}
        </b>
      </p>
      <p class="mb-0">
        Status:
        <b [className]="getStatusClass()">
          {{ getStatusText() }}
        </b>
      </p>
    </div>

    <div class="mt-3">
      <p class="mb-0">Related Customers</p>
      <ul class="mb-0">
        <li *ngFor="let customer of document.related_customers">
          <a [routerLink]="'/customers/' + customer.id.toString()" target="_blank">
            {{ customer.first_name }} {{ customer.last_name }}
          </a>
          <ng-container *ngIf="customer.is_expired">
            -
            <span class="text-danger">Expired for Customer</span>
          </ng-container>
        </li>
      </ul>
    </div>

    <ng-container *ngIf="document.is_usable_for_entry">

      <div class="mt-3">
        <p class="mb-0">Climber Customers</p>
        <ul class="mb-0">
          <li *ngFor="let customer of document.climber_customers">
            <a [routerLink]="'/customers/' + customer.id.toString()" target="_blank">
              {{ customer.first_name }} {{ customer.last_name }}
            </a>
            <ng-container *ngIf="customer.is_expired">
              -
              <span class="text-danger">Expired for Customer</span>
            </ng-container>
          </li>
        </ul>
        <small class="text-muted d-block">
          The climber customers may use this document as a Waiver/AoR for entry purposes, if the document is valid and not expired.
        </small>
      </div>

      <div *ngIf="!document.can_be_used_for_barcode_check_in" class="alert alert-info">
        This document may not be used as a Waiver/AoR for entry via the Check-In Site barcode scanner. It may still be used for entry via the Staff Site check-in functions, however.
      </div>

    </ng-container>

    <div *ngIf="errorMessage !== ''"
         class="alert alert-danger mt-3 mb-0">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Close
    </button>
    <button type="button" class="btn btn-success"
            *ngIf="markAsValidAvailable()"
            (click)="handleChangeValidity(true)">
      Mark as Valid
    </button>
    <button type="button" class="btn btn-danger"
            *ngIf="markAsInvalidAvailable()"
            (click)="handleChangeValidity(false)">
      Mark as Invalid
    </button>
    <button type="button" class="btn btn-secondary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
